import { connect } from 'react-redux';
import { getModals } from '../../../../../../../store/modals/selectors';
import { getErrorMessage, getViewedProductGroup } from '../../../../../../../store/associations/selectors';
import AddAssociationTable from './AddAssociationTable';
import { setOpenModal } from '../../../../../../../store/modals/actions';
import { addAssociation } from '../../../../../../../store/associations/actions';

const mapStateToProps = (state) => ({
  modals: getModals(state),
  errorMessage: getErrorMessage(state),
  viewedProductGroup: getViewedProductGroup(state),
});

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (modal, value) => {
    dispatch(setOpenModal(modal, value));
  },

  addAssociation: (
    multiplier,
    groupIRI,
    associationIRI,
  ) => dispatch(
    addAssociation(
      multiplier,
      groupIRI,
      associationIRI,
    ),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAssociationTable);
